/*=========================================================================================
  File Name: moduleAdminCouponList.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleAdminCouponListState.js'
import mutations from './moduleAdminCouponListMutations.js'
import actions from './moduleAdminCouponListActions.js'
import getters from './moduleAdminCouponListGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

